import React from "react";
import product from "../../assets/images/bg.png";
import { getImageUrl } from "../../helper/constants";

const AgricultureCard = ({ product_data }) => {
  return (

    <div className="ver_card_wrapp">
      <div className="product_card veg_card">
        <div className="product_card_image">
          <img src={getImageUrl(product_data?.pic)} />{" "}
        </div>

        <div className="veg_card_text">
          <div className="veg_cat">{product_data?.parentId?.name} </div>
          <div className="veg_name">{product_data?.name}</div> </div>
      </div>
    </div>
  );
};

export default AgricultureCard;
